import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {ListItemType} from 'hiya-common/src/reducers/commonTypes'
import {http} from 'hiya-common/src/utils/axios'
import {camelizeKeys, decamelizeKeys} from 'humps'
import {useSelector} from 'react-redux'

// 获取配置信息页 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=17594790
export const getPkConfig = createAsyncThunk(
  '/live/activity/fmpk_get_config',
  async (arg: void, store: any) => {
    const resp = await http.post<HiyaRes<any>>(
      '/live/activity/fmpk_get_config',
      store.getState().env.deviceinfo,
      {
        xcErrorToast: true,
      }
    )
    return camelizeKeys(resp.data)
  }
)

// 家族排行榜 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=17595373
export const pkRankList = createAsyncThunk(
  '/live/activity/fmpk_rank_list',
  async ({dayIdx}: {dayIdx: number}, store: any) => {
    const resp = await http.post('/live/activity/fmpk_rank_list', {
      ...store.getState().env.deviceinfo,
      day_idx: dayIdx,
    })
    return camelizeKeys(resp.data)
  }
)
// 家族积分任务 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=17595207

export const fmPkSchedule = createAsyncThunk(
  '/live/activity/fmpk_schedule',
  async ({dayIdx}: {dayIdx: number}, store: any) => {
    const resp = await http.post('/live/activity/fmpk_schedule', {
      ...store.getState().env.deviceinfo,
      day_idx: dayIdx,
    })
    return camelizeKeys(resp.data)
  }
)

export const fmPkDetail = createAsyncThunk(
  '/live/activity/fmpk_detail',
  async (
    {
      dayIdx,
      pkRoundIdx,
    }: {
      dayIdx: number
      pkRoundIdx: number
    },
    store: any
  ) => {
    const resp = await http.post('/live/activity/fmpk_detail', {
      ...store.getState().env.deviceinfo,
      day_idx: dayIdx,
      pk_round_idx: pkRoundIdx,
    })
    return camelizeKeys(resp.data)
  }
)

export const fmPkSubscibe = createAsyncThunk(
  '/live/activity/fmpk_subscribe',
  async (
    {
      dayIdx,
      pkRoundIdx,
    }: {
      dayIdx: number
      pkRoundIdx: number
    },
    store: any
  ) => {
    const resp = await http.post('/live/activity/fmpk_subscribe', {
      ...store.getState().env.deviceinfo,
      day_idx: dayIdx,
      pk_round_idx: pkRoundIdx,
    })
    return camelizeKeys(resp.data)
  }
)

const transRankList = (arr) => {
  const tempList = [].concat(arr)
  tempList.forEach((item: any) => {
    const {memberInfo} = item
    const temp = item
    if (item.familyLeader) {
      const tempId = item.familyLeader
      // 将家族长的id赋值给原本的结构，然后删除家族长的id
      memberInfo.id = tempId
      delete temp.familyLeader
    }
  })
  return tempList
}

export enum PageTypeEnum {
  PK = 1,
  point = 2,
  rank = 3,
}
export interface MemberProps {
  avatar: string
  id: number
  name: string
  zyId: string
  roomId?: number
}

export interface RankItemType {
  rank: number
  memberInfo: MemberProps
  score: number
}

export interface ScheduleItemType {
  id: number
  type: 0 | 1
  title: string
  desc: string
  progressRate: Array<number>
  icon: string
  topList: Array<RankItemType>
}
export interface RoundItemType {
  time: string
  players: Array<number>
}

export interface OwnFamilyInfoType {
  name: string
  icon: string
  familyRank: number
  familyScore: number
  familyId: number
  ownScore: number
  ownRank: number
  ownId: number
  ownIcon: string
}

export interface PlayerInfoItemType {
  familyName: string
  familyId: number
  familyIcon: string
  familyRoom: number
  score: number
  contributeList: Array<RankItemType>
}

export interface InitialStateType {
  todayIdx?: number
  dayList?: Array<any>
  transFormPeriods?: Array<any>
  peroidIdx?: number
  peroids?: Array<any>
  familyRankRewards?: Array<any>
  // 按照213排列的
  transFamilyRankRewards?: Array<any>
  pkRounds?: Array<RoundItemType>
  myMid?: number
  pkRoundIdx?: number
  isYesterdayRound?: boolean
  ownFamilyId?: number
  ownFamilyRank?: RankItemType
  hasOwnFamilyRank?: boolean
  familyRankListCountDown?: number
  familyRankList?: RankItemType[]
  transFamilyRankList?: ListItemType[]
  // 积分任务列表
  scheduleList?: ScheduleItemType[]
  ownFamily?: OwnFamilyInfoType
  // 家族积分贡献前三
  contributeRankList?: ListItemType[]

  // PK信息榜
  // 0:PK双方信息还未公示;1: PK双方信息已经公示但比赛未开始;2: PK进行中
  // 1: PK双方信息已经公示但比赛未开始;2: PK进行中；3：Pk结束
  pkStatus?: 0 | 1 | 2 | 3
  pkRange?: Array<string>
  pkExpire?: number
  poolCoins?: number
  playerInfos?: PlayerInfoItemType[]
  isSubscribe?: boolean
}

const initialState: InitialStateType = {}

export const FamilyPKSlice = createSlice({
  name: 'FamilyPK',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fmPkSubscibe.fulfilled, (state, action) => {
      Object.assign(state, {
        isSubscribe: true,
      })
    })
    builder.addCase(getPkConfig.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      const ret = {
        todayIdx: data.todayIdx,
        dayList: data.dayList || [],
        peroidIdx: data.peroidIdx,
        peroids: data.peroids || [],
        familyRankRewards: data.familyRankRewards || [],
        // 奖励按照213排列
        transFamilyRankRewards: data.familyRankRewards
          ? [
              data.familyRankRewards[1],
              data.familyRankRewards[0],
              data.familyRankRewards[2],
            ]
          : [],
        pkRounds: data.pkRounds || [],
        pkRoundIdx: data.pkRoundIdx,
        isYesterdayRound: data.isYesterdayRound,
        ownFamilyId: data.ownFamilyId,
        transFormPeriods: data.peroids
          ? [
              data.peroids[data.peroidIdx],
              data.peroids[Number(!data.peroidIdx)],
            ]
          : [],
        // 获得用户的id
        myMid: data.mid,
      }
      Object.assign(state, ret)
    })

    builder.addCase(pkRankList.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      const ret: any = {
        familyRankListCountDown: data.countDown,
        familyRankList: data.list || [],
        transFamilyRankList: data.list
          ? transRankList(decamelizeKeys(data.list))
          : [],
      }
      if (data.own) {
        ret.hasOwnFamilyRank = true
        ret.ownFamilyRank = data.own
      } else {
        // 没有就将这个变量置为false
        ret.hasOwnFamilyRank = false
      }
      Object.assign(state, ret)
    })
    builder.addCase(fmPkSchedule.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      const ret: any = {
        scheduleList: data.scheduleList || [],
        contributeRankList: decamelizeKeys(data.contributeRankList) || [],
      }
      if (data.ownFamily) {
        // 家族信息
        ret.ownFamily = data.ownFamily
      }
      Object.assign(state, ret)
    })
    builder.addCase(fmPkDetail.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      const ret = {
        pkStatus: data.status,
        pkRange: data.range || [],
        pkExpire: data.pkExpire,
        poolCoins: data.poolCoins,
        playerInfos: data.playerInfos || [],
        isSubscribe: data.isSubscribe,
      }
      Object.assign(state, ret)
    })
  },
})
export default FamilyPKSlice.reducer
export const useFamilyPKState = () => {
  const data = useSelector((state) => state.FamilyPK)
  return data
}
